import React, { SVGProps } from 'react';

const Delete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5601 33.615L10 13.3333H30L28.4399 33.615C28.3798 34.3965 27.7281 34.9999 26.9443 34.9999H13.0557C12.2719 34.9999 11.6202 34.3965 11.5601 33.615ZM14.0906 23.4823L13.3333 16.6666H26.6667L25.9197 23.3898L14.0906 23.4823Z"
      fill="#919ED0"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3333 7.5V5.5C23.3333 5.22386 23.1095 5 22.8333 5H17.1667C16.8905 5 16.6667 5.22386 16.6667 5.5V7.5H8.83334C8.5572 7.5 8.33334 7.72386 8.33334 8V9.5C8.33334 9.77614 8.5572 10 8.83334 10H31.1667C31.4428 10 31.6667 9.77614 31.6667 9.5V8C31.6667 7.72386 31.4428 7.5 31.1667 7.5H23.3333Z"
      fill="#6C7DC0"
    />
  </svg>
);

export default Delete;
